/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {ChangesInfo} from '../models/ChangesInfo';
import type {Error} from '../models/Error';
import type {OverageSettings} from '../models/OverageSettings';

export interface GetOverageEnabled$Request {
    accountId: number;
}

export interface GetOverageEnabled$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getOverageEnabledRequest = createAction<PayloadData<void, GetOverageEnabled$Request>>('OVERAGE_SETTINGS_CONTROLLER__GET_OVERAGE_ENABLED__REQUEST');
export const getOverageEnabledSuccess = createAction<PayloadData<OverageSettings, GetOverageEnabled$Request>>('OVERAGE_SETTINGS_CONTROLLER__GET_OVERAGE_ENABLED__SUCCESS');
export const getOverageEnabledFailure = createAction<PayloadData<Error, GetOverageEnabled$Request, true>>('OVERAGE_SETTINGS_CONTROLLER__GET_OVERAGE_ENABLED__FAILURE');

export const getOverageEnabledActions = [
    getOverageEnabledRequest,
    getOverageEnabledSuccess,
    getOverageEnabledFailure
] as const;

/**
 * Overage status switcher
 * @param {number} meta.accountId Id of account
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getOverageEnabled = (meta: GetOverageEnabled$Request, config?: GetOverageEnabled$Config) => {
    return {
        CALL_API: {
            types: getOverageEnabledActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/api-v2/${meta.accountId}/settings/overage`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateOverageStatus$Request {
    accountId: number;
    overageSettings?: OverageSettings;
}

export interface UpdateOverageStatus$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateOverageStatusRequest = createAction<PayloadData<void, UpdateOverageStatus$Request>>('OVERAGE_SETTINGS_CONTROLLER__UPDATE_OVERAGE_STATUS__REQUEST');
export const updateOverageStatusSuccess = createAction<PayloadData<ChangesInfo, UpdateOverageStatus$Request>>('OVERAGE_SETTINGS_CONTROLLER__UPDATE_OVERAGE_STATUS__SUCCESS');
export const updateOverageStatusFailure = createAction<PayloadData<Error, UpdateOverageStatus$Request, true>>('OVERAGE_SETTINGS_CONTROLLER__UPDATE_OVERAGE_STATUS__FAILURE');

export const updateOverageStatusActions = [
    updateOverageStatusRequest,
    updateOverageStatusSuccess,
    updateOverageStatusFailure
] as const;

/**
 * Overage enable
 * @param {number} meta.accountId Id of account
 * @param {OverageSettings} [meta.overageSettings]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateOverageStatus = (meta: UpdateOverageStatus$Request, config?: UpdateOverageStatus$Config) => {
    return {
        CALL_API: {
            types: updateOverageStatusActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/api-v2/${meta.accountId}/settings/overage`,
            TRANSPORT_REQUEST_BODY: meta.overageSettings,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

